/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StreetInputs */

const en__field_street = /** @type {(inputs: _Field_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const de__field_street = /** @type {(inputs: _Field_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {_Field_StreetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_street = /** @type {((inputs?: _Field_StreetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StreetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_street(inputs)
	return de__field_street(inputs)
});